























































import { Component, Mixins, Prop } from 'vue-property-decorator'
import { IFormStore } from '@/store/types'
import { kintaiInputStore } from '@/store/form/KintaiInputFormStore'
import * as ApiPath from '@/tcw/constant/ApiPath'
import FormStoreComponent from '@/tcw/components/FormStoreComponent'
import { ApiGeneralSinglePayload, EditableResponse } from '@/tcw/api/types'
import { MobileAction, TcwFormDate } from '@/tcw/domain/types'
import { API_DAYTIME_FORMAT } from '@/tcw/domain/format'
import { KeyInfo } from '@/components/common/form/types'
import { TCWApiError } from '@/plugins/TCWBaseError'
import { ERR_CODE_WEB_API_NOT_FOUND } from '@/tcw/constant/ErrorCode'
import fab from 'vue-fab'

@Component({
  components: { fab }
})
export default class TimeCardForm extends Mixins(FormStoreComponent) {
  @Prop({ type: Date, default: () => new Date() })
  private inputDate!: Date

  private nowTime = new Date()

  /**
   * FAB設定
   */
  get mobileActions(): MobileAction[] {
    const actions = []
    if (!this.form.kaishi) {
      actions.push({
        name: 'saveKaishiTime',
        tooltip: '開始時間を記録',
        icon: 'meeting_room',
        color: '#1e90ff'
      })
    }
    actions.push({
      name: 'saveShuryoTime',
      tooltip: '終了時間を記録',
      icon: 'directions_run',
      color: '#1e90ff'
    })
    return actions
  }

  get formName(): string {
    return 'kintaiInputForm'
  }
  get storeModule(): IFormStore<ApiGeneralSinglePayload> {
    return kintaiInputStore
  }
  get keyInfo(): KeyInfo {
    return {
      year: this.inputDate.getFullYear(),
      month: this.inputDate.getMonth() + 1,
      day: this.inputDate.getDate()
    }
  }
  get isEmptyRecord(): boolean {
    return false
  }

  get form(): ApiGeneralSinglePayload {
    return this.storeModule.editData !== null ? this.storeModule.editData : {}
  }

  get inputDateStr(): string {
    return this.du.convertDateToStr(this.nowTime, 'yyyy年MM月DD日')
  }

  get currentTimeStr(): string {
    const date = this.du.convertDateToStr(this.nowTime, 'yyyy-MM-DD')
    const time = this.du.convertDateToStr(this.nowTime, 'HH:mm:ss')
    return `${date} ${time}`
  }

  get kintaiJikanStr(): string {
    let kaishi = '未記録'
    let shuryo = '未記録'
    if (this.kaishiDate) {
      kaishi = this.du.convertDateToStr(this.kaishiDate, 'HH:mm')
    }
    if (this.shuryoDate) {
      shuryo = this.du.convertDateToStr(this.shuryoDate, 'HH:mm')
    }
    return `${kaishi} - ${shuryo}`
  }

  get kaishiDate(): TcwFormDate {
    if (this.form.kaishi && typeof this.form.kaishi === 'string') {
      return this.tcw.dateOf(this.form.kaishi)
    } else {
      return null
    }
  }
  set kaishiDate(newDate: TcwFormDate) {
    const dateStr = this.du.convertDateToStr(newDate, API_DAYTIME_FORMAT)
    this.updateValue('kaishi', dateStr)
  }
  get shuryoDate(): TcwFormDate {
    if (this.form.shuryo && typeof this.form.shuryo === 'string') {
      return this.tcw.dateOf(this.form.shuryo)
    } else {
      return null
    }
  }
  set shuryoDate(newDate: TcwFormDate) {
    const dateStr = this.du.convertDateToStr(newDate, API_DAYTIME_FORMAT)
    this.updateValue('shuryo', dateStr)
  }
  get biko(): string {
    if (typeof this.form.biko === 'string') {
      return this.form.biko
    } else {
      return ''
    }
  }
  set biko(biko: string) {
    this.updateValue('biko', biko)
  }

  public saveKaishiTime(): void {
    // 時刻を15分単位に補正 TODO 15分をシステム変数化
    const minute = this.nowTime.getMinutes()
    const amari = minute % 15
    this.nowTime.setMinutes(minute + (15 - amari))
    this.kaishiDate = this.nowTime
    this.startSaveProc()
  }
  public saveShuryoTime(): void {
    // 時刻を15分単位に補正 TODO 15分をシステム変数化
    const minute = this.nowTime.getMinutes()
    const amari = minute % 15
    this.nowTime.setMinutes(minute - amari)
    this.shuryoDate = this.nowTime
    this.startSaveProc()
  }

  protected async afterProc(): Promise<void> {
    this.fetchRecordTime()
  }

  private async fetchRecordTime() {
    const path = ApiPath.buildPath(ApiPath.Paths.KintaiExists.get, this.keyInfo)
    try {
      const response = await this.getWebApi().call<EditableResponse<ApiGeneralSinglePayload>>(path, 'GET')
      this.kaishiDate = this.tcw.dateOf(response.payload.kaishi as string)
      this.shuryoDate = this.tcw.dateOf(response.payload.shuryo as string)
    } catch (e) {
      if (e instanceof TCWApiError && e.getErrorCode() === ERR_CODE_WEB_API_NOT_FOUND) {
        // NOT FOUNDは想定
        this.kaishiDate = null
        this.shuryoDate = null
      } else {
        throw e
      }
    }
  }

  protected mounted(): void {
    setInterval(() => (this.nowTime = new Date()), 1000)
  }

  protected async validate(): Promise<void> {
    // 入力しないためバリデーションはから実行する
  }

  protected async afterSaveProc(): Promise<void> {
    this.clearForm()
    this.$tcw.message({
      type: 'success',
      title: '時間を記録しました',
      message: 'デフォルト勤怠パターンで勤怠データを保存しました。'
    })
    this.goto('/kintai/list')
  }
}
